import * as React from "react";
import { Link } from "react-router-dom";
import t from "../i18n";
import { formatDate } from "../utils";
import { cardStyles } from "../_styles/receiptcard";
import { css } from "emotion";
import classNames from "classnames";

export default class SupportTicketBlock extends React.Component<{ticket: any}> {
    render() {
        const ticket = this.props.ticket;
        return <div className="form-group">
            <div className={classNames(["receipt-card", css(cardStyles.white)])}>
                <div className="row" style={{ paddingLeft: 40 }}>
                    <div className="col-sm-12">
                        <span className="fa-stack" style={{ position: "absolute", top: -5, left: -30 }}>
                            <i className="fa fa-comment-o fa-stack-2x" />
                            <span className="fa-stack-1x" style={{ fontSize: 14 }}>{ticket.comment_count}</span>
                        </span>
                        <Link to={`/ticket/edit?ticketId=${ticket.id}`} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", width: "100%", overflow: "hidden", display: "inline-block" }}>
                            {ticket.subject}
                        </Link>
                    </div>
                </div>
                <div className="row" style={{ paddingLeft: 40 }}>
                    <div className="col-sm-4"><span style={{ fontSize: 13, color: "#767676" }}>{t.myaccount("createdOnLabel")}: {formatDate(ticket.created_at)}</span></div>
                    <div className="col-sm-4"><span style={{ fontSize: 13, color: "#767676" }}>{t.myaccount("updatedOnLabel")}: {formatDate(ticket.updated_at)}</span></div>
                    <div className="col-sm-4"><span style={{ fontSize: 13, color: "#767676" }}>{t.myaccount("statusLabel")}: {ticket.status}</span></div>
                </div>
            </div>
        </div>
    }
}